import { Form } from "components";

const cashbackImportStatuses = [
  { label: "Importado", value: "imported" },
  { label: "Contabilizado", value: "accounted" },
];

export default function Filters({
  filters,
  onChange,
  onClean,
  access,
  stores,
}) {
  return (
    <Form>
      <div className="row">
        <Form.Field className="col-md-6">
          <Form.Label>CPF</Form.Label>
          <Form.Input
            placeholder="123.123.123-12"
            value={filters.cpf}
            onChange={(event) => onChange("cpf", event.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-6">
          <Form.Label>Assessor</Form.Label>
          <Form.Input
            placeholder="Nome do Assessor"
            value={filters.accessorName}
            onChange={(event) => onChange("accessorName", event.target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Período, de</Form.Label>
          {/* <Form.Icon name="calendar" /> */}
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.start_at}
            onChange={(value) => onChange("start_at", value)}
            minDate={new Date(2023, 0, 1)}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Período, até</Form.Label>
          {/* <Form.Icon name="calendar" /> */}
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={filters.end_at}
            onChange={(value) => onChange("end_at", value)}
            minDate={filters.start_at}
            maxDate={new Date()}
            disabled={!filters.start_at}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Loja</Form.Label>
          <Form.Select
            name="store"
            placeholder="Todas"
            onChange={(value) => onChange("store", value)}
            value={filters.store}
            options={stores.map((store) => ({
              value: store.id,
              label: store.name,
            }))}
            noOptionsMessage={() => "Nenhuma loja encontrada"}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar filtros
          </Form.Button>
        </Form.Field>
      </div>
    </Form>
  );
}
